import { costBreakdownV2WidgetSetupDataSelector } from "./costBreakdownV2WidgetSetupDataSelector";
import { RootState } from "../../../../../store";

export const costBreakdownV2WidgetSetupTotalCostDateDetailsSelector = (
  state: RootState,
) => {
  return costBreakdownV2WidgetSetupDataSelector(state)?.total_cost_date_details;
};
